import styled from "styled-components";

const B1 = {
  fontFamily: "Mark For MC Narrow W00 Light",
  fontStyle: "normal",
  fontWeight: 350,
  fontSize: "16px",
  lineHeight: "24px",
  letterSpacing: "0.5px",
  color: "#CCCCCC",
};

const HEADER = {
  fontFamily: "Mark For MC Narrow W00 Light",
  fontStyle: "normal",
  fontSize: "24px",
  lineHeight: "32px",
  color: "#FFF",
  textAlign: "center",
};

const rowSpaceBetween = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
};

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 480px;
  margin: auto;
  min-height: 100vh;
  background-color: #000000;
  padding-top: 24px;
`;

export const Intro = styled.section`
  background-color: #282827;
  margin: 0px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 16px;
  gap: 40px;
  border-radius: 6px;

  h1 {
    ${HEADER}
  }

  p {
    ${B1}
    text-align: center;
  }

  img {
    height: 74px;
    margin: auto;
  }
`;

export const ViewBalance = styled.div`
  background-color: #282827;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 22.5px 0;
  border-radius: 6px;
  margin: 0 16px;

  .balance-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 0 16px;
  }

  p {
    ${B1}
    text-align: center;
  }
  .balance {
    text-align: center;
    ${HEADER}
  }
`;

export const Wearable = styled.div`
  margin: 0 35px;
  border-radius: 6px;
  margin: 0 16px;
  background-color: #282827;
  img {
    width: 100%;
    height: auto;
    object-fit: contain;
    aspect-ratio: 1;
  }
`;

export const PaymentAccount = styled.section`
  padding: 24px 16px;
  gap: 16px;
  background-color: #282827;
  display: flex;
  flex-direction: column;
  margin: 0 16px;
  border-radius: 6px;

  h2 {
    ${HEADER}
    text-align: left;
  }

  p {
    ${B1}
    color: white;
  }

  .bb-logo {
    height: 48px;
    width: 141px;
  }

  .button {
    max-width: 222px;
    border-radius: 5px;
    background: #fff;
    height: 35px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      color: #ffffff;
    }
  }


  .activation-code {
    width: 100%;
    padding: 12px 16px;
    margin-bottom: 8px;
    ${rowSpaceBetween}
    border-radius: 5px;
    border: 1px solid #fff;
    p {
      color: #fff;
      font-size: 28px;
      font-weight: 700;
      line-height: 36px;
    }
    img{
      color: #ffffff;
    }
  }

  .stores {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    gap: 8px;
  }

  .line {
    border: 1px solid #e0e0e0;
    width: 100%;
    height: 1px;
  }

  .or-separator {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    p {
      margin: 0px 16px;
    }
  }
`;

export const Footer = styled.div`
  background-color: #282827;
  margin-top: 8px;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  align-items: center;

  p {
    ${B1}
  }

  img {
    height: 34px;
    margin-bottom: 8px;
    cursor: pointer;
  }
`;
